import { render, staticRenderFns } from "./resourceLibraryDetail.vue?vue&type=template&id=53bdb2c6&scoped=true"
import script from "./resourceLibraryDetail.vue?vue&type=script&lang=js"
export * from "./resourceLibraryDetail.vue?vue&type=script&lang=js"
import style0 from "./resourceLibraryDetail.vue?vue&type=style&index=0&id=53bdb2c6&prod&lang=scss"
import style1 from "./resourceLibraryDetail.vue?vue&type=style&index=1&id=53bdb2c6&prod&lang=scss&scoped=true"
import style2 from "./resourceLibraryDetail.vue?vue&type=style&index=2&id=53bdb2c6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53bdb2c6",
  null
  
)

export default component.exports